document.addEventListener('DOMContentLoaded', function () {

  // Open modal
  document.querySelectorAll('[data-creatine-modal-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modalId = btn.getAttribute('data-creatine-modal-open');
      var modal = document.getElementById(modalId);
      if (modal) {
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Close modal (overlay click or close button)
  document.querySelectorAll('[data-creatine-modal-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var modal = el.closest('.creatine-modal');
      if (modal) {
        modal.setAttribute('hidden', true);
        document.body.style.overflow = '';
      }
    });
  });

  // Variant selection highlight
  document.querySelectorAll('.creatine-variant-option').forEach(function (label) {
    label.addEventListener('click', function () {
      var group = label.closest('.creatine-modal__variants');
      group.querySelectorAll('.creatine-variant-option').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      label.classList.add('is-selected');
    });
  });

  // Add to cart (AJAX)
  document.querySelectorAll('[data-creatine-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = btn.closest('.creatine-modal');
      var selectedInput = modal.querySelector('input[type="radio"]:checked');

      if (!selectedInput) {
        alert('Please select an option');
        return;
      }

      var variantId = selectedInput.value;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          btn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            modal.setAttribute('hidden', true);
            document.body.style.overflow = '';
            btn.disabled = false;
            btn.innerHTML = '<span class="icon-cart"></span> ADD TO CART';
          }, 1000);
        })
        .catch(function (error) {
          alert(error.message);
          btn.disabled = false;
          btn.innerHTML = '<span class="icon-cart"></span> ADD TO CART';
        });
    });
  });

});